/**
 * Gallery Builder Module Loader
 */

import './gallery-config.js';
import './stores/index.js';  // Load all modular stores
import './gallery-builder.js';
import './components/gallery-carousel.js';
import { ensureMembershipModalLoaded } from './services/membership/membership-modal-loader.js';

ensureMembershipModalLoaded();
if (typeof Alpine === 'undefined') {
  console.error('Alpine.js is not loaded. Gallery Builder requires Alpine.js to function.');
}
